import React from "react";
import { useState, useEffect } from "react";
import Header from "../../../../Components/Header/Header";
import SideBar from "../../../../Components/SideBar/SideBar";
import { getProduct } from "../../../../api/ProductApi/productSlice";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./UpdateProduct.scss";
import UpdateProductOne from "./ProductOne/UpdateProductOne";
import UpdateProductTwo from "./ProductTwo/UpdateProductTwo";
import UpdateProductThree from "./ProductThree/UpdateProductThree";

const UpdateProduct = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const [currentPage, setCurrentPage] = useState(1);
    const handleNext = () => setCurrentPage((p) => p + 1);
    const handlePrev = () => setCurrentPage((p) => p - 1);

    useEffect(() => {
        dispatch(getProduct(id));
    }, [dispatch, id]);

    const product = useSelector((state) => state?.products?.products?.product);

    const [name,            setName]            = useState("");
    const [category,        setCategory]        = useState([]);
    const [desc,            setDesc]            = useState("");
    const [modelNum,        setModelNum]        = useState("");
    const [isActive,        setIsActive]        = useState("");
    const [featured,        setFeatured]        = useState("");
    const [images,          setImages]          = useState([]);
    const [seo,             setSeo]             = useState("");
    const [selectedOption,  setSelectedOption]  = useState(null);
    const [productLocation, setProductLocation] = useState("");

    // ── specs state — pre-populated from existing product.specifications ──
    const [specs, setSpecs] = useState([{ label: "", value: "" }]);

    useEffect(() => {
        if (product) {
            setName(product.name ?? "");
            setCategory(product.categories?.[0]?.id ?? []);
            setDesc(product.description ?? "");
            setModelNum(product.model_no ?? "");
            setIsActive(product.is_active ?? "");
            setProductLocation(product.location ?? "");
            setFeatured(product.featured ?? "");
            setSeo(product.seo ?? "");
            setSelectedOption(
                product?.lang
                    ? { value: product.lang.id, label: product.lang.name }
                    : null
            );

            // map existing DB specs (key/value) → local shape (label/value)
            if (product.specifications?.length > 0) {
                setSpecs(
                    product.specifications.map((s) => ({
                        label: s.key   ?? "",
                        value: s.value ?? "",
                    }))
                );
            } else {
                setSpecs([{ label: "", value: "" }]);
            }
        }
    }, [product]);

    const data = {
        name:          name          ?? product?.name          ?? "",
        categories:    [category ?? product?.categories?.[0]?.id].filter(
            (v) => v !== undefined && v !== null
        ),
        description:   desc          ?? product?.description   ?? "",
        model_no:      modelNum      ?? product?.model_no      ?? "",
        is_active:     isActive      ?? product?.is_active      ?? 0,
        featured:      featured      ?? product?.featured      ?? 0,
        image:         images        ?? [],
        location:      productLocation ?? product?.location    ?? "",
        language_id:   selectedOption?.value ?? product?.lang?.id ?? null,
        seo:           seo           ?? product?.seo           ?? "",
        specifications: specs,   // ← included so UpdateProductTwo can send it
    };

    return (
        <div className="updateProductContainer">
            <SideBar />
            <div>
                <Header title="Update Product" />
                <div className="productWrapper">
                    <div className="productAdd">

                        {currentPage === 1 && (
                            <UpdateProductOne
                                product={product}
                                onNext={handleNext}
                                name={name}                     setName={setName}
                                productLocation={productLocation} setProductLocation={setProductLocation}
                                category={category}             setCategory={setCategory}
                                desc={desc}                     setDesc={setDesc}
                                seo={seo}                       setSeo={setSeo}
                                modelNum={modelNum}             setModelNum={setModelNum}
                                isActive={isActive}             setIsActive={setIsActive}
                                featured={featured}             setFeatured={setFeatured}
                                selectedOption={selectedOption} setSelectedOption={setSelectedOption}
                                specs={specs}                   setSpecs={setSpecs}
                            />
                        )}

                        {currentPage === 2 && (
                            <UpdateProductTwo
                                id={id}
                                product={product}
                                onNext={handleNext}
                                onPrev={handlePrev}
                                setImages={setImages}
                                images={images}
                                data={data}
                            />
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateProduct;